import { render } from "./ProductRecommendationItem.vue?vue&type=template&id=311b082a"
import script from "./ProductRecommendationItem.vue?vue&type=script&lang=js"
export * from "./ProductRecommendationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__